<template>
  <div>
    <div class="sidebar-container mt-50px">
      <a
        :href="selectedBusiness.properties.link"
        v-if="selectedBusiness.properties.visible"
        ><h2
          class="section-title"
          v-html="selectedBusiness.properties.name"
        ></h2
      ></a>
      <h2
        v-else
        class="section-title"
        v-html="selectedBusiness.properties.name"
      ></h2>
      <div class="double-dashed-border"></div>
      <div
        class="organisation-info mt-20px"
        v-if="
          !selectedBusiness.properties.vente_en_ligne_uniquement &&
          !selectedBusiness.properties.commerce_uniquement
        "
      >
        <div><map-maker-icon class="organisation-icons" /></div>
        <div v-html="selectedBusiness.properties.address"></div>
      </div>
      <div
        v-if="selectedBusiness.properties.vente_en_ligne_uniquement"
        class="warning mt-10px"
      >
        Cette entreprise offre la vente en ligne uniquement
      </div>
      <div
        v-if="selectedBusiness.properties.commerce_uniquement"
        class="warning mt-10px"
      >
        Cette entreprise vend ses produits dans des commerces seulement.
      </div>
      <div class="organisation-info mt-10px">
        <div><phone-icon class="organisation-icons" /></div>
        <div>
          <a :href="'tel:+' + selectedBusiness.properties.phone">{{
            selectedBusiness.properties.phone
          }}</a>
        </div>
      </div>
      <div
        class="organisation-info mt-10px"
        v-if="selectedBusiness.properties['site-url']"
      >
        <div><web-icon class="organisation-icons" /></div>
        <div>
          <a :href="selectedBusiness.properties['site-url']" target="_blank"
            >Site Web</a
          >
        </div>
      </div>
      <div
        class="organisation-info mt-20px"
        v-if="
          !selectedBusiness.properties.vente_en_ligne_uniquement &&
          !selectedBusiness.properties.commerce_uniquement
        "
      >
        <div><map-marker-path-icon class="organisation-icons" /></div>
        <div>
          <b
            ><a
              :href="
                'https://www.google.ca/maps/dir/Current+Location/' +
                selectedBusiness.properties.address
              "
              target="_blank"
              >Obtenir l'itinéraire</a
            ></b
          >
        </div>
      </div>
      <div class="small-line"></div>
      <div v-if="selectedBusiness.properties.point_de_service">
        <div><h2 class="section-title">Points de service</h2></div>
        <div class="double-dashed-border"></div>
        <div
          v-for="(pointService, index) in selectedBusiness.properties
            .point_de_service"
          :key="index"
          class="mt-20px"
        >
          <div
            class="organisation-info"
            @click="
              zoomTo(pointService.position.lat, pointService.position.lng)
            "
            style="cursor: pointer"
          >
            <b>{{ pointService.nom_entreprise }}</b>
          </div>
          <div class="organisation-info mt-10px">
            <map-maker-icon class="organisation-icons" />
            {{ pointService.numero_civique }} {{ pointService.local }}
            {{ pointService.rue }} {{ pointService.municipalite }},
            {{ pointService.code_postal }}
          </div>
          <div class="organisation-info">
            <a :href="'tel:+' + pointService.numero_de_telephone"
              ><phone-icon class="organisation-icons" />{{
                pointService.numero_de_telephone
              }}</a
            >
          </div>
        </div>
      </div>
      <div class="d-flex align-center space-between">
        <h2 class="section-title">Produits offerts</h2>
        <div :class="{ open: !produits }">
          <close-icon-outline class="cursor" @click="produits = !produits" />
        </div>
      </div>
      <div class="double-dashed-border"></div>
      <div class="mt-20px" v-show="produits">
        <div
          v-if="
            selectedBusiness.properties.produits_transformes ||
            selectedBusiness.properties.oeufs_et_viandes ||
            selectedBusiness.properties.fruits_et_legumes ||
            selectedBusiness.properties.produits_artisanaux
          "
        ></div>
        <ul v-if="selectedBusiness.properties.produits_transformes !== null">
          <li
            v-for="(produit, index) in selectedBusiness.properties
              .produits_transformes"
            :key="index"
            class="sidebar-right-element"
          >
            {{ produit }}
          </li>
        </ul>
        <ul v-if="selectedBusiness.properties.oeufs_et_viandes !== null">
          <li
            v-for="(oeufs_et_viandes, index) in selectedBusiness.properties
              .oeufs_et_viandes"
            :key="index"
            class="sidebar-right-element"
          >
            {{ oeufs_et_viandes }}
          </li>
        </ul>
        <ul v-if="selectedBusiness.properties.fruits_et_legumes !== null">
          <li
            v-for="(fruits_et_legumes, index) in selectedBusiness.properties
              .fruits_et_legumes"
            :key="index"
            class="sidebar-right-element"
          >
            {{ fruits_et_legumes }}
          </li>
        </ul>
        <ul v-if="selectedBusiness.properties.produits_artisanaux !== null">
          <li
            v-for="(produits_artisanaux, index) in selectedBusiness.properties
              .produits_artisanaux"
            :key="index"
            class="sidebar-right-element"
          >
            {{ produits_artisanaux }}
          </li>
        </ul>
      </div>
      <div class="small-line"></div>
      <div class="d-flex align-center space-between">
        <h2 class="section-title">Lieux de vente</h2>
        <div :class="{ open: !lieuxDeVente }">
          <close-icon-outline
            class="cursor"
            @click="lieuxDeVente = !lieuxDeVente"
          />
        </div>
      </div>
      <div class="double-dashed-border"></div>
      <div class="mt-20px" v-show="lieuxDeVente">
        <div
          v-if="
            selectedBusiness.properties.lieux_de_vente &&
            selectedBusiness.properties.lieux_de_vente.length !== 0
          "
        >
          <ul>
            <li
              v-for="(lieux_de_vente, index) in selectedBusiness.properties
                .lieux_de_vente"
              :key="index"
              class="sidebar-right-element"
            >
              {{ lieux_de_vente }}
            </li>
          </ul>
          <div class="mt-20px">
            <div
              v-for="(precision, index) in selectedBusiness.properties
                .precision"
              :key="index"
            >
              <div v-if="precision == 'Marque du produit à rechercher'">
                <div class="pl-10px sidebar-right-element-dark">
                  {{ precision }} :
                </div>
                <div v-if="selectedBusiness.properties.marque_produit">
                  <ul>
                    <li
                      class="sidebar-right-element"
                      v-for="(marque, key) in selectedBusiness.properties
                        .marque_produit"
                      :key="key"
                    >
                      {{ marque.nom_du_produit }}
                    </li>
                  </ul>
                </div>
                <div class="pl-10px no-data mt-20px" v-else>
                  Aucune information pour ce sujet
                </div>
              </div>
            </div>
            <div
              class="element-business mt-20px"
              v-for="(businessAvailable, index) in selectedBusiness.properties
                .point_de_distribution"
              :key="index"
              @click="zoomToDistributeur(businessAvailable.ID)"
            >
              <map-marker-left-icon />
              <div class="pl-10px">{{ businessAvailable.post_title }}</div>
            </div>
          </div>
        </div>
        <div v-else class="no-data">Aucune information pour ce sujet</div>
      </div>
      <div class="small-line"></div>
      <div class="d-flex align-center space-between">
        <h2 class="section-title">Services</h2>
        <div :class="{ open: !services }">
          <close-icon-outline class="cursor" @click="services = !services" />
        </div>
      </div>
      <div class="double-dashed-border"></div>
      <div class="mt-20px" v-show="services">
        <div
          v-if="
            !selectedBusiness.properties.vente_en_ligne &&
            !selectedBusiness.properties.toilettes_publiques_sur_place &&
            !selectedBusiness.properties.aire_de_repas_sur_place
          "
          class="no-data"
        >
          Aucune information pour ce sujet
        </div>
        <div
          v-if="selectedBusiness.properties.vente_en_ligne"
          class="sidebar-right-element-dark"
        >
          <div>
            <img :src="require('../assets/images/vente_web.png')" />
          </div>
          <div class="pl-10px">Vente en ligne</div>
        </div>
        <div
          v-if="selectedBusiness.properties.toilettes_publiques_sur_place"
          class="sidebar-right-element-dark"
        >
          <div>
            <img :src="require('../assets/images/toilet.png')" />
          </div>
          <div class="pl-10px">Toilettes publiques sur place</div>
        </div>
        <div
          v-if="selectedBusiness.properties.aire_de_repas_sur_place"
          class="sidebar-right-element-dark"
        >
          <div>
            <img :src="require('../assets/images/repas.png')" />
          </div>
          <div class="pl-10px">Aire de repas sur place</div>
        </div>
      </div>
      <div class="d-flex align-center space-between">
        <h2 class="section-title">À savoir</h2>
        <div :class="{ open: !aSavoir }">
          <close-icon-outline class="cursor" @click="aSavoir = !aSavoir" />
        </div>
      </div>
      <div class="double-dashed-border"></div>
      <div class="mt-20px" v-show="aSavoir">
        <div
          v-if="
            selectedBusiness.properties.precision &&
            selectedBusiness.properties.precision.length !== 0
          "
        >
          <div
            v-for="(precision, index) in selectedBusiness.properties.precision"
            :key="index"
          >
            <div class="sidebar-right-element-dark">
              <div v-if="precision == 'Produits biologiques'">
                <img :src="require('../assets/images/bxs_leaf.png')" />
              </div>
              <div v-if="precision == 'Ouverture saisonnière seulement'">
                <img :src="require('../assets/images/saison.png')" />
              </div>
              <div v-if="precision == 'Argent comptant seulement'">
                <img :src="require('../assets/images/cash.png')" />
              </div>
              <div v-if="precision == 'Sur réservation seulement'">
                <img :src="require('../assets/images/calendar.png')" />
              </div>
              <div
                class="pl-10px"
                v-if="precision !== 'Marque du produit à rechercher'"
              >
                {{ precision }}
              </div>
            </div>
          </div>
        </div>
        <div v-else class="no-data">Aucune information pour ce sujet</div>
      </div>
      <div class="mb-50px"></div>
    </div>
  </div>
</template>
<script>
import L from 'leaflet'
import methods from '../mixins/methods'
export default {
  data () {
    return {
      produits: true,
      lieuxDeVente: true,
      aSavoir: true,
      services: true,
      distributionTemp: null
    }
  },
  mixins: [methods],
  methods: {
    zoomTo: function (lat, lng) {
      this.lmap.flyTo([lat, lng], 14)
    },
    zoomToDistributeur: function (id) {
      if (this.distributionTemp !== null) {
        this.lmap.removeLayer(this.distributionTemp)
      }
      let geom = this.distribution.features.find(
        (element) => element.properties.id === id
      )
      this.lmap.flyTo(
        [geom.geometry.coordinates[1], geom.geometry.coordinates[0]],
        17
      )
      if (
        this.lieux.includes('Marchés publics') ||
        this.lieux.includes('Kiosques à la ferme')
      ) {
      } else {
        let iconCommerce = require('../assets/images/commerce.png')
        // eslint-disable-next-line
        this.distributionTemp = new L.marker(
          [geom.geometry.coordinates[1], geom.geometry.coordinates[0]],
          {
            // eslint-disable-next-line
            icon: L.icon({
              iconUrl: iconCommerce,
              iconSize: [30, 35]
            })
          }
        )
        this.distributionTemp.addTo(this.lmap).on('click', function () {
          this.bounce(3)
        })
      }
    }
  },
  props: {
    selectedBusiness: Object,
    lmap: Object,
    distribution: Object,
    lieux: Array
  }
}
</script>



// WEBPACK FOOTER //
// src/components/InfoProducteur.vue